module.exports = __webpack_public_path__ + "static/media/landing_shot2.aede4c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/landing_shot2.jpg
// module id = 235
// module chunks = 27